// @flow
import type { ApplicationState } from '../../state/types'

import React, { Component } from 'react'
import { connect } from 'react-redux'

import { withTranslate } from '../translation'
import { gbiProjectActions } from '../../state/gbiProject/actions'
import { gbiProjectSelectors } from '../../state/gbiProject/selectors'

import { Notification } from '../common/Notification'
import { SelectProvince } from '../select_province'

import './register.css'

type Props = {
  error: ?string,
  isLoading: boolean,
  t: Function,
  onRegister: (
    name: string,
    dogName: string,
    age: string,
    sex: string,
    breed: string,
    houseNo: string,
    villageNo: string,
    lane: string,
    road: string,
    subDistrict: string,
    district: string,
    province: string,
    zipcode: string,
    tel: string,
    email: string,
  ) => void,
  onCloseError: () => void,
}

type State = {
  name: string,
  dogName: string,
  age: string,
  sex: string,
  breed: string,
  houseNo: string,
  villageNo: string,
  lane: string,
  road: string,
  subDistrict: string,
  district: string,
  province: string,
  zipcode: string,
  tel: string,
  email: string,
}

class RegisterForm extends Component<Props, State> {
  state = {
    name: '',
    dogName: '',
    age: '',
    sex: 'male',
    breed: '',
    houseNo: '',
    villageNo: '',
    lane: '',
    road: '',
    subDistrict: '',
    district: '',
    province: 'กระบี่',
    zipcode: '',
    tel: '',
    email: '',
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    const {
      name,
      dogName,
      age,
      sex,
      breed,
      houseNo,
      villageNo,
      lane,
      road,
      subDistrict,
      district,
      province,
      zipcode,
      tel,
      email,
    } = this.state
    const { onRegister, isLoading } = this.props

    if (!isLoading) {
      onRegister(name, dogName, age, sex, breed, houseNo, villageNo, lane,
        road, subDistrict, district, province, zipcode, tel, email,)
    }
    e.preventDefault()
  }

  render() {
    const { error, isLoading, t, onCloseError } = this.props
    const { province, sex } = this.state
    return (
      <div className="sign-in-form pt-10 flex justify-center">
        <form onSubmit={this.handleSubmit} className="w-full px-4 lg:w-3/5 lg:px-0 xl:w-3/5 xl:px-0">
          <h1>{t(`RegisterForm.title`)}</h1>
          <label>{t(`RegisterForm.name`)}</label>
          <input
            type="text"
            name="name"
            className="input"
            onChange={this.handleChange}
            required={true}
            autoFocus={true}
            autoComplete="off"
          />
          <label>{t('RegisterForm.dogName')}</label>
          <input
            type="text"
            name="dogName"
            className="input"
            onChange={this.handleChange}
            required={true}
            autoFocus={true}
            autoComplete="off"
          />
          <label>{t('RegisterForm.dogAge')}</label>
          <input
            type="text"
            name="dogAge"
            className="input"
            onChange={this.handleChange}
            required={true}
            autoFocus={true}
            autoComplete="off"
          />

          <div className="pt-4">
            <label>{t('RegisterForm.sex.title')}</label>
            <div className="flex flex-col">
              <label htmlFor="sex" className="radio-label">
                <input
                  type="radio"
                  id="1"
                  name="sex"
                  value="male"
                  checked={sex == "male"}
                  onChange={this.handleChange}
                  className=""
                />
                <span className="checkmark"></span>
                <span className="tick"></span>
                <span className="choice-span pl-2">ผู้</span>
              </label>
              <label htmlFor="sex" className="radio-label">
                <input
                  type="radio"
                  id="2"
                  name="sex"
                  value="female"
                  checked={sex == "female"}
                  onChange={this.handleChange}
                  className=""
                />
                <span className="checkmark"></span>
                <span className="tick"></span>
                <span className="choice-span pl-2">เมีย</span>
              </label>
            </div>
          </div>

          <label>{t('RegisterForm.breed')}</label>
          <input
            type="text"
            name="breed"
            className="input"
            onChange={this.handleChange}
            required={true}
            autoFocus={true}
            autoComplete="off"
          />
          <label>{t('RegisterForm.address.title')}</label>
          <div className="pt-4">
            <div className="flex">
              <div className="w-1/2 pr-8">
                <label>{t('RegisterForm.address.houseNo')}</label>
                <input
                  type="text"
                  name="houseNo"
                  className="input mb-4"
                  onChange={this.handleChange}
                  required={true}
                  autoFocus={true}
                  autoComplete="off"
                />
              </div>
              <div className="w-1/2 pl-8">
                <label>{t('RegisterForm.address.villageNo')}</label>
                <input
                  type="text"
                  name="villageNo"
                  className="input mb-4"
                  onChange={this.handleChange}
                  required={true}
                  autoFocus={true}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="flex">
              <div className="w-1/2 pr-8">
                <label>{t('RegisterForm.address.lane')}</label>
                <input
                  type="text"
                  name="lane"
                  className="input mb-4"
                  onChange={this.handleChange}
                  required={true}
                  autoFocus={true}
                  autoComplete="off"
                />
              </div>
              <div className="w-1/2 pl-8">
                <label>{t('RegisterForm.address.road')}</label>
                <input
                  type="text"
                  name="road"
                  className="input mb-4"
                  onChange={this.handleChange}
                  required={true}
                  autoFocus={true}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="flex">
              <div className="w-1/2 pr-8">
                <label>{t('RegisterForm.address.subDistrict')}</label>
                <input
                  type="text"
                  name="subDistrict"
                  className="input mb-4"
                  onChange={this.handleChange}
                  required={true}
                  autoFocus={true}
                  autoComplete="off"
                />
              </div>
              <div className="w-1/2 pl-8">
                <div className="pr-2 self-center">
                  {t('RegisterForm.address.district')}
                </div>
                <input
                  type="text"
                  name="province"
                  className="input"
                  onChange={this.handleChange}
                  required={true}
                  autoFocus={true}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="flex">
              <div className="w-1/2 pr-8">
                <div className="">{t('RegisterForm.address.province')}</div>
                <SelectProvince
                  value={province}
                  name="province"
                  handleChange={this.handleChange}
                  className="self-center w-full"
                  t={t}
                />
              </div>

              <div className="w-1/2 pl-8">
                <label>{t('RegisterForm.address.zipcode')}</label>
                <input
                  type="text"
                  name="zipcode"
                  className="input"
                  onChange={this.handleChange}
                  required={true}
                  autoFocus={true}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
          <label>{t('RegisterForm.tel')}</label>
          <input
            type="text"
            name="tel"
            className="input"
            onChange={this.handleChange}
            required={true}
            autoFocus={true}
            autoComplete="off"
          />
          <label>{t('RegisterForm.email')}</label>
          <input
            type="text"
            name="email"
            className="input"
            onChange={this.handleChange}
            required={true}
            autoFocus={true}
            autoComplete="off"
          />
  

        {error && (
          <Notification
            message= {t('RegisterForm.duplicate')}
            className="is-danger mt-4"
            handleClose={onCloseError}
          />
        )}
     
          <button type="submit" className="button is-dark" disabled={isLoading}>
            {t('RegisterForm.submit')}
          </button>
        </form>
        <div className="bg-teal-300 text-teal-800 p-4 m-4 rounded-lg border-4 border-teal-200	">
          <p className="text-xl font-extrabold text-center pb-2">
            สิทธิพิเศษที่คุณจะได้จากการเข้าร่วมโครงการ Goodbye Itch Project
          </p>
          <div className="flex items-center pb-2">
            <img src="images/marker.png" />
            <p className="pl-2">
              สามารถเข้าร่วมกิจกรรมต่างๆที่จัดขึ้นโดยโครงการ Goodbye Itch
              Project โดยไม่เสียค่าใช้จ่าย
            </p>
          </div>
          <div className="flex items-center ">
            <img src="images/marker.png" />
            <p className="pl-2">
              ได้รับสิทธิ์ในการตรวจผิวหนังตามโอกาสที่ทางโครงการ Goodbye Itch
              Project จัดขึ้นโดยไม่เสียค่าใช้จ่าย
            </p>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: ApplicationState): any => {
  return {
    error: gbiProjectSelectors.getError(state),
    isLoading: gbiProjectSelectors.isLoading(state),
  }
}

const mapDispatchToProps = (dispatch: Function): any => {
  return {
    onRegister: (
      name: string,
      dogName: string,
      age: string,
      sex: string,
      breed: string,
      houseNo: string,
      villageNo: string,
      lane: string,
      road: string,
      subDistrict: string,
      district: string,
      province: string,
      zipcode: string,
      tel: string,
      email: string,
    ) => {
      dispatch(
        gbiProjectActions.register(
          name,
          dogName,
          age,
          sex,
          breed,
          houseNo,
          villageNo,
          lane,
          road,
          subDistrict,
          district,
          province,
          zipcode,
          tel,
          email,
        ),
      )
    },
    onCloseError: () => {
      dispatch(gbiProjectActions.setError(null))
    },
  }
}

export default withTranslate(
  connect(mapStateToProps, mapDispatchToProps)(RegisterForm),
)
